import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F4FBF8] text-[#17231F]">
      <Header />
      <Hero />
      <Features />
      <Footer />
    </div>
  );
}
